/** User-facing text from an Axios / ASP.NET ProblemDetails error. */
export function formatHttpErrorMessage(error: unknown, fallback: string): string {
    const data = (error as { response?: { data?: unknown } })?.response?.data;
    if (data && typeof data === 'object') {
        const problem = data as {
            errors?: Record<string, string | string[]>;
            detail?: string;
            title?: string;
            message?: string;
        };
        if (problem.errors && typeof problem.errors === 'object') {
            const messages = Object.values(problem.errors)
                .flatMap((value) => (Array.isArray(value) ? value : [value]))
                .map((value) => String(value).trim())
                .filter(Boolean);
            if (messages.length) return messages.join(' ');
        }
        const detail = [problem.detail, problem.title, problem.message]
            .find((value) => typeof value === 'string' && value.trim());
        if (detail) return detail.trim();
    }
    if (error instanceof Error && error.message.trim()) {
        return error.message.trim();
    }
    return fallback;
}
